<template>
  <div>
    <TheNav />
    <TheActions />

    <main ref="wrapper" class="h-scroll-wrapper">
      <div ref="track" class="h-scroll-track">
        <div class="h-scroll-panel">
          <HomeHero />
        </div>
        <div class="h-scroll-panel">
          <HomeProjects />
        </div>
        <div class="h-scroll-panel">
          <HomeAiStudio />
        </div>
        <div class="h-scroll-panel">
          <HomeBlog />
        </div>
        <div class="h-scroll-panel">
          <HomeContact />
        </div>
        <div class="h-scroll-panel">
          <HomeExploreMore />
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
// Page transitions and horizontal-scroll setup
import { onMounted, onBeforeUnmount, nextTick, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { personalInfo } from '~/data/content';

gsap.registerPlugin(ScrollTrigger);

// This page had no head block at all, so it rendered an empty <title> while
// every other route set one. It is the page most likely to be shared, indexed
// and bookmarked, and all three were showing the bare URL.
//
// Name first rather than the role, since the tab is usually truncated and the
// name is the half worth keeping.
useHead({
  title: `${personalInfo.fullName} - Full Stack Engineer`,
  meta: [
    { name: 'description', content: personalInfo.tagline },
    { property: 'og:title', content: `${personalInfo.fullName} - Full Stack Engineer` },
    { property: 'og:description', content: personalInfo.tagline },
    { name: 'twitter:title', content: `${personalInfo.fullName} - Full Stack Engineer` },
    { name: 'twitter:description', content: personalInfo.tagline },
  ],
});

const wrapper = ref(null);
const track = ref(null);
const { start, stop } = useHorizontalScroll();

onMounted(() => {
  nextTick(() => {
    start(wrapper, track);
  });
});

// Before, not after, unmount: GSAP injects the pin-spacer as a parent of the
// wrapper, and it can only unwind that while the nodes are still in the DOM.
// From onUnmounted the subtree is already detached, orphaning the spacer.
onBeforeUnmount(() => {
  stop();
});

// A per-section `.animate-in` sweep used to live here. It was removed: the only
// `.animate-in` elements on the page are in the hero, which runs its own
// entrance in animateTextElements() — so this replayed that same fromTo from
// (y: 50, opacity: 0), and its `top 70%` trigger fires immediately for the
// hero. That double animation was the whole of what it did, plus one
// ScrollTrigger per section for nothing.
</script>
